const items = [
  "SMM PRECISION",
  "BRAND DEALS",
  "SMART SOURCING",
  "CREATOR ECONOMY",
  "EST. 2018",
  "42 CR+ ORDERS",
  "₹710 CR+ VALUE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((it, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 text-3xl tracking-tight sm:text-5xl ${
            i % 2 ? "font-serif italic text-gold-grad" : "font-semibold text-neutral-700"
          }`}
        >
          {it}
        </span>
        <span className="h-2 w-2 rotate-45 bg-gold/50" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/5 bg-[#08080B] py-8"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
